/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FollowingCompany,
    FollowingCompanyFromJSON,
    FollowingCompanyFromJSONTyped,
    FollowingCompanyToJSON,
} from './FollowingCompany';

/**
 * 
 * @export
 * @interface FollowingCompaniesResponseAllOfData
 */
export interface FollowingCompaniesResponseAllOfData {
    /**
     * フォロー中の企業一覧
     * @type {Array<FollowingCompany>}
     * @memberof FollowingCompaniesResponseAllOfData
     */
    companies: Array<FollowingCompany>;
    /**
     * フォロー中企業の総数
     * @type {number}
     * @memberof FollowingCompaniesResponseAllOfData
     */
    totalCount: number;
    /**
     * 次のデータを取得する開始点となる識別子
     * @type {string}
     * @memberof FollowingCompaniesResponseAllOfData
     */
    nextCursor?: string;
}

export function FollowingCompaniesResponseAllOfDataFromJSON(json: any): FollowingCompaniesResponseAllOfData {
    return FollowingCompaniesResponseAllOfDataFromJSONTyped(json, false);
}

export function FollowingCompaniesResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FollowingCompaniesResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companies': ((json['companies'] as Array<any>).map(FollowingCompanyFromJSON)),
        'totalCount': json['total_count'],
        'nextCursor': !exists(json, 'next_cursor') ? undefined : json['next_cursor'],
    };
}

export function FollowingCompaniesResponseAllOfDataToJSON(value?: FollowingCompaniesResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companies': ((value.companies as Array<any>).map(FollowingCompanyToJSON)),
        'total_count': value.totalCount,
        'next_cursor': value.nextCursor,
    };
}

